import { Orientation } from "assets/images";

const Rotate = () => {
  return (
    <div className="rotateBg">
      <img alt="rotateImg" src={Orientation} className="rotateImg" />
      <div className="textRotation"> ....لطفا دستگاه خود را عمودی کنید</div>
    </div>
  );
};

export default Rotate;
